import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { brandGradient } from "../shared-theme/themePrimitives";

export default function HeaderContent() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
        textAlign: "center",
      }}
    >
      <Typography
        variant="h1"
        gutterBottom
        sx={{
          fontSize: { xs: "2.25rem", sm: "2.75rem" },
          fontWeight: 700,
          background: brandGradient,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          display: "inline-block",
        }}
      >
        Where Brands Meet Influence
      </Typography>
      <Typography color="text.secondary" style={{ fontWeight: "bolder" }}>
        Connect. Collaborate. Grow.
      </Typography>
    </Box>
  );
}
